'use strict'

var STORAGE_KEYS = Object.freeze({
    ID_TOKEN: 'authSessionData_idToken',
    ACCESS_TOKEN: 'authSessionData_accessToken',
    ACCESS_TOKEN_TYPE: 'authSessionData_accessTokenType',
    TOKEN_EXPIRES_AT: 'authSessionData_tokenExpiresAt',
    SSO_USER: 'authSessionData_ssoUser',
    CUSTOM_LOGIN: 'customLogin',
    COGNITO_ID_TOKEN: 'authSessionData_cognito_idToken',
    SSO_STATE: 'ssoState',
    PKCE_VERIFIER: 'pkce_verifier',
    COGNITO_CONFIG: 'cognito_config',
    LOGIN_RETURN_PATH: 'loginReturnPath',
    COGNITO_REFRESH_TOKEN: 'authSessionData_cognito_refreshToken'
})

if (typeof angular !== 'undefined') {
    angular.module('app').constant('STORAGE_KEYS', STORAGE_KEYS)
}
